import { render, staticRenderFns } from "./ClinicDiagDic.vue?vue&type=template&id=f5b2c086"
import script from "./ClinicDiagDic.vue?vue&type=script&lang=js"
export * from "./ClinicDiagDic.vue?vue&type=script&lang=js"
import style0 from "./ClinicDiagDic.vue?vue&type=style&index=0&id=f5b2c086&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-store\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f5b2c086')) {
      api.createRecord('f5b2c086', component.options)
    } else {
      api.reload('f5b2c086', component.options)
    }
    module.hot.accept("./ClinicDiagDic.vue?vue&type=template&id=f5b2c086", function () {
      api.rerender('f5b2c086', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/page/dictionary/ClinicDiagDic.vue"
export default component.exports